
import { SheetModal } from '@components/SheetModal'
import { SheetModalHandle } from '@components/SheetModalHandle'

import { Input } from './Input'
import { CommentsList } from './List'

interface IDisplayComments {
  comment: string
  createdOn: Date
  id: number
  user: {
    firstName: string
    lastName: string
  }
}

interface IProps {
  openModal: boolean
  comments: IDisplayComments[]
  handleComment: (comment: string) => void
  onClose: () => void
  isReadOnly?: boolean
}

export function CommentsModal({
  openModal,
  comments,
  handleComment,
  onClose,
  isReadOnly,
}: IProps) {
  const modalHandler = () => (
    <SheetModalHandle>{`${comments.length} comments`}</SheetModalHandle>
  )

  return (
    <div>
      <SheetModal
        initialSnap={4}
        onClose={onClose}
        open={openModal}
        handle={modalHandler}
      >
        <CommentsList comments={comments} />
        {!isReadOnly && (
          <div>
            <Input onSave={handleComment} />
          </div>
        )}
      </SheetModal>
    </div>
  )
}
